import React from 'react'
import PropTypes from 'prop-types'

import { SectionBlock } from '../SectionBlock/SectionBlock'
import { TopSectionTitle } from '../TopSectionTitle/TopSectionTitle'

import './AboutSection.css'

const AboutSection = ({ title = '', split = false, description }) => {
    const className = split ? 'split' : ''

    return (
        <SectionBlock withContainer>
            <TopSectionTitle title={title} underlined centered dark />
            <div
                className={`about-section__content about-section__content--${className}`}
                dangerouslySetInnerHTML={description}
            />
        </SectionBlock>
    )
}

AboutSection.propTypes = {
    title: PropTypes.string,
    split: PropTypes.bool,
    description: PropTypes.shape({
        __html: PropTypes.string
    })
}

export { AboutSection }
